import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';
import { useGetProjectSelectionItemsByIdQuery } from 'redux-store/api/selections';
import { useAppSelector } from 'redux-store/hooks/useAppSelector';
import { authSelector } from 'redux-store/selector';
import SelectionModal from 'widgets/selections/modals/selection-modal';

export const SelectionHashtagModal = ({
  projectId,
  onClose,
}: {
  projectId: number;
  onClose: () => void;
}) => {
  const selectionItemId = useAppSelector((state) => state.hashtag.selectionItemId);
  const { companyId } = useAppSelector(authSelector);

  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery(undefined, {
    skip: !companyId,
  });

  const { data: selection } = useGetProjectSelectionItemsByIdQuery({
    selectionId: selectionItemId!,
  });

  if (!selection || !userPermissions.MANAGE_SELECTIONS.canRead) return null;

  const costCategory = { name: selection?.costCode?.name, number: selection?.costCode?.id };

  return (
    <SelectionModal
      projectId={projectId}
      open
      handleClose={onClose}
      selection={selection}
      costCategory={costCategory}
      isEdit={true}
    />
  );
};
